import { render, staticRenderFns } from "./group_detail.vue?vue&type=template&id=5a4ab22a&scoped=true"
import script from "./group_detail.vue?vue&type=script&lang=js"
export * from "./group_detail.vue?vue&type=script&lang=js"
import style0 from "./group_detail.vue?vue&type=style&index=0&id=5a4ab22a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4ab22a",
  null
  
)

export default component.exports